import React from 'react';
import { Box, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';

interface HeadingProps {
  title: string;
  subtitle?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heading: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: '8px',
      borderBottom: '1px solid #efefef',
    },
    headingLeft: {
      flex: 1,
    },
    headingTitle: {
      color: theme.color.grey.neutralBrand900,
      fontWeight: 600,
      fontSize: 20,
    },
  })
);

export function Heading({ title, subtitle }: HeadingProps) {
  const classes = useStyles();
  return (
    <Box className={classes.heading}>
      <Box className={classes.headingLeft}>
        <Typography variant='h2' className={classes.headingTitle}>
          {title}
        </Typography>
        {subtitle && <Typography variant={'body2'}>{subtitle}</Typography>}
      </Box>
    </Box>
  );
}
